var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"even:bg-white odd:bg-gray-50"},[_c('td',{staticClass:"px-4 py-4 text-sm text-gray-500"},[_vm._v(" "+_vm._s(_vm.fullName)+" ")]),_c('td',{staticClass:"px-4 py-4 text-sm text-gray-500"},[(_vm.contact.primary_email_address)?_c('span',[_vm._v(" "+_vm._s(_vm.contact.primary_email_address.address)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }